<div class="basket">
  @if (repeating(); as repeat) {
    <!-- Gentag periode (#1138): the side sheet's own view, back to the basket with the arrow. -->
    <div class="basket-repeat">
      <button mat-button type="button" class="basket-repeat__back" (click)="repeating.set(null)">
        <mat-icon>arrow_back</mat-icon>
        Tilbage til kurven
      </button>
      <!-- The time being repeated, as its card in the basket. -->
      <app-checkout-card class="basket-item">
        <app-checkout-card-header [title]="$safeNavigationMigration(basketStore.getActivity(repeat.item.activityId)?.name)" />
        <app-booking-period-details [availabilityType]="repeat.item.availabilityType">
          <app-icon-label icon="home" [text]="getItemResourceName(repeat.item)"></app-icon-label>
          <app-date-icon-label-variations [startDate]="repeat.item.start" [endDate]="repeat.item.end" />
        </app-booking-period-details>
      </app-checkout-card>
      <app-repeated-booking
        [selectedPeriod]="repeat.selectedPeriod"
        [currentPeriods]="repeat.currentPeriods"
        [userId]="userAssociation().userId"
        [showMissingPrice]="repeat.item.availabilityType !== 'REQUEST'"
        variant="chips"
        (periodsSelected)="onRepeatChosen($event)"
        (closed)="repeating.set(null)"
      />
    </div>
  } @else if (basketStore.combinedBasketItems().length === 0) {
    <div>
      <h4>Kurven er tom</h4>
      <p>For at kunne gennemføre et køb, skal du søge efter ledige tider, og tilføje dem til kurven.</p>

      {{ association }}
    </div>
    @if (basketStore.isPending()) {
      <mat-spinner diameter="24"></mat-spinner>
    }
  } @else {
    <div class="basket-content">
      <app-checkout-card>
        <h4 class="mb-0">{{ location()?.name }}</h4>
      </app-checkout-card>

      @for (series of basketSeries(); track series.key) {
        @let item = series.items[0];
        @let single = series.items.length === 1;
        @let removeLabel = single ? 'Fjern fra kurv' : 'Fjern alle datoer fra kurv';
        @let open = openSeries().has(series.key);
        <!-- One card for a line, or for a repeated time's dates (#1138): the same header, its own body. -->
        <app-checkout-card
          class="basket-item"
          [class.basket-series]="!single"
          [class.unavailable]="series.unavailable"
          tabindex="0"
          role="group"
        >
          <app-checkout-card-header
            [title]="$safeNavigationMigration(basketStore.getActivity(item.activityId)?.name)"
            [hasMenu]="true"
            inlineActionsFrom="compact"
          >
            <!-- Shown as icons when the card has room for them, else under ⋮ (below). -->
            <button
              card-header-action
              mat-icon-button
              type="button"
              matTooltip="Gentag periode"
              aria-label="Gentag periode"
              (click)="onRepeatBasketItem(item)"
            >
              <mat-icon>repeat</mat-icon>
            </button>
            <button
              card-header-action
              mat-icon-button
              type="button"
              [matTooltip]="removeLabel"
              [attr.aria-label]="removeLabel"
              (click)="single ? removeItem(item) : removeSeries(series.items)"
            >
              <mat-icon>delete</mat-icon>
            </button>
            <button mat-menu-item (click)="single ? removeItem(item) : removeSeries(series.items)">
              <mat-icon class="text-danger" aria-hidden="false" [attr.aria-label]="removeLabel">delete</mat-icon>
              <span>{{ removeLabel }}</span>
            </button>
            <button mat-menu-item (click)="onRepeatBasketItem(item)">
              <mat-icon aria-hidden="false" aria-label="Gentag periode">repeat</mat-icon>
              <span>Gentag periode</span>
            </button>
          </app-checkout-card-header>

          @if (single) {
              <app-booking-period-details [availabilityType]="item.availabilityType">
                <app-icon-label icon="home" [text]="getItemResourceName(item)"></app-icon-label>
                <app-date-icon-label-variations [startDate]="item.start" [endDate]="item.end" />

                @if (!item.isLoading) {
                  <app-icon-label
                    icon="payment"
                    [text]="item.price ? (item.price | currency: 'DKK' : 'symbol') : 'Prisen er ikke tilgængelig'"
                  ></app-icon-label>
                } @else {
                  <mat-spinner diameter="24"></mat-spinner>
                }

                @if (item.message) {
                  <mat-chip-set aria-label="fejl i booking periode">
                    <mat-chip class="abook-chip --error">{{ item.message }}</mat-chip>
                  </mat-chip-set>
                }
              </app-booking-period-details>
          } @else {
              <app-booking-period-details [availabilityType]="item.availabilityType">
                <app-icon-label icon="home" [text]="getItemResourceName(item)"></app-icon-label>
                <app-icon-label
                  icon="schedule"
                  [text]="'Kl. ' + (item.start | danishDate: 'time') + ' - ' + (item.end | danishDate: 'time')"
                ></app-icon-label>
                <app-icon-label
                  icon="payment"
                  [text]="series.price ? (series.price | currency: 'DKK' : 'symbol') : 'Prisen er ikke tilgængelig'"
                ></app-icon-label>

                <!-- The dates fold open (#1138, Max 24-10-2026): the count and how it repeats, then each date. -->
                <button
                  type="button"
                  class="basket-series__toggle"
                  [class.basket-series__toggle--open]="open"
                  [attr.aria-expanded]="open"
                  (click)="toggleSeries(series.key)"
                >
                  <mat-icon class="basket-series__toggle-icon" aria-hidden="true">event_repeat</mat-icon>
                  <span class="basket-series__toggle-text">
                    <strong>{{ series.items.length }} datoer</strong>
                    <span>
                      {{ series.rhythm }} ·
                      {{ series.items[0].start | danishDate: 'dayMonthYear' }} –
                      {{ series.items[series.items.length - 1].start | danishDate: 'dayMonthYear' }}
                    </span>
                    @if (series.unavailable) {
                      <span class="basket-series__toggle-warn">Nogle datoer kan ikke bookes · Vis datoer</span>
                    }
                  </span>
                  <mat-icon class="basket-series__toggle-chevron" aria-hidden="true">{{
                    open ? 'expand_less' : 'expand_more'
                  }}</mat-icon>
                </button>
                @if (open) {
                <ul class="basket-series__dates" [attr.aria-label]="series.items.length + ' datoer'">
                  @for (date of series.items; track date.id) {
                    <li [class.unavailable]="!date.isAvailable">
                      <span class="basket-series__date">
                        <mat-icon aria-hidden="true">event</mat-icon>
                        {{ date.start | danishDate: 'weekdayDate' | capitalizeFirst }}
                      </span>
                      @if (date.isLoading) {
                        <mat-spinner diameter="18"></mat-spinner>
                      } @else {
                        <button
                          mat-icon-button
                          type="button"
                          class="basket-series__remove"
                          matTooltip="Fjern datoen fra kurv"
                          [attr.aria-label]="'Fjern ' + (date.start | danishDate: 'weekdayDate') + ' fra kurv'"
                          (click)="removeItem(date)"
                        >
                          <mat-icon>close</mat-icon>
                        </button>
                      }
                      @if (date.message) {
                        <mat-chip-set aria-label="fejl i booking periode" class="basket-series__message">
                          <mat-chip class="abook-chip --error">{{ date.message }}</mat-chip>
                        </mat-chip-set>
                      }
                    </li>
                  }
                </ul>
                }
              </app-booking-period-details>
          }
        </app-checkout-card>
      }

      <app-checkout-card color="emphasized">
        @if (basketStore.itemsCount() === 0) {
          <p class="empty-basket">Kurven er tom</p>
        } @else {
          <div class="total-price">
            <div class="label"><strong>Samlet pris:</strong></div>
            <div class="value">{{ basketStore.total() | currency: 'DKK' : 'symbol' }}</div>
          </div>
        }
      </app-checkout-card>

      @if (isRequest()) {
        <!-- A request is not booked yet (design 3a/3b). Ikke i repoet: boksen og teksten. -->
        <div class="request-note" role="note">
          <mat-icon aria-hidden="true">hourglass_top</mat-icon>
          <span>
            <strong>Kræver godkendelse</strong>
            Anlægget skal godkende tiden, før den er booket. Du får besked på mail, når forespørgslen
            er behandlet.
          </span>
        </div>
      }

      <div class="actions mt-2 mb-2">
        <abook-button
          size="large"
          type="filled"
          class="checkout-button"
          [disabled]="basketStore.itemsCount() === 0"
          (clickFn)="checkout()"
        >
          @if (checkoutStore.requestStatus() === 'pending') {
            <div class="mat-spinner-container">
              <mat-spinner class="spinner-white" diameter="20"></mat-spinner>
            </div>
          } @else {
            <span>{{ isRequest() ? 'Send forespørgsel' : 'Videre' }}</span>
          }
        </abook-button>

        @if (basketStore.itemsCount() > 0) {
          <abook-button type="text" size="small" class="clear-basket-button" (clickFn)="confirmClearBasket()">
            Tøm kurv
          </abook-button>
        }
      </div>

      @if (checkoutError()) {
        <mat-chip class="abook-chip --error mt-2 checkout-error">{{ checkoutError() }}</mat-chip>
      }
    </div>
  }
</div>
